import React, { FC } from 'react';

interface IPulseBadgeProps {
  className?: string;
}

const PulseBadge: FC<IPulseBadgeProps> = ({ className }) => (
  <span className={`${className || ''} flex h-[8px] w-[8px]`}>
    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-90 opacity-75"></span>
    <span className="relative inline-flex h-full w-full rounded-full bg-red-90"></span>
  </span>
);

export default PulseBadge;
